// eslint-disable-next-line @typescript-eslint/no-explicit-any
type FilterQueryKey = Record<string, any>

export const generateQueryKeys = <T extends string>(baseName: T) => {
  const keys = {
    all: [baseName] as const,
    lists: () => [...keys.all, 'list'] as const,
    list: (filters?: FilterQueryKey) => [...keys.lists(), filters] as const,
    details: () => [...keys.all, 'detail'] as const,
    detail: (id: string | number, filters?: FilterQueryKey) => [...keys.details(), id, filters] as const
  }

  return keys
}
